import { render, staticRenderFns } from "./taxi-goa-airport.vue?vue&type=template&id=12c3eede&scoped=true"
import script from "./taxi-goa-airport.vue?vue&type=script&lang=js"
export * from "./taxi-goa-airport.vue?vue&type=script&lang=js"
import style0 from "./taxi-goa-airport.vue?vue&type=style&index=0&id=12c3eede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3eede",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
